import React from 'react';
import { DashboardStats } from '../../types/dashboard.types';
import { StatsCard } from './StatsCard';
import './StatsGrid.styles.css';

interface StatsGridProps {
  stats: DashboardStats;
}

export const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  return (
    <div className="stats-grid">
      <StatsCard
        icon="home"
        iconClass="active"
        value={stats.totalActive}
        label="Dossiers actifs"
      />
      <StatsCard
        icon="check"
        iconClass="visited"
        value={stats.visitedThisWeek}
        label="Visites cette semaine"
      />
      <StatsCard
        icon="document"
        iconClass="pending"
        value={stats.pendingReports}
        label="Rapports en attente"
      />
      <StatsCard
        icon="alert"
        iconClass="urgent"
        value={stats.urgentTasks}
        label="Tâches urgentes"
      />
    </div>
  );
};